import { useEffect, useState } from 'react';
import { adminApi } from '@formosa/shared/api/admin';
import { formatDateTime } from '@formosa/shared/utils/formatDateTime';
import { resolveAdminMediaUrl } from '@formosa/shared/utils/mediaUrl';
import {
  formatKycJourneyAction,
  formatRealNameStatus,
  kycStatusClassName,
  statusCode,
} from './kycConstants';

export default function KycJourneyModal({ open, memberId, onClose }) {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open || !memberId) {
      setRecords([]);
      setError('');
      return;
    }
    let cancelled = false;
    setLoading(true);
    setError('');
    adminApi
      .kycJourney(memberId)
      .then((data) => {
        if (!cancelled) {
          setRecords(Array.isArray(data) ? data : []);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.message || '載入失敗');
          setRecords([]);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [open, memberId]);

  if (!open) {
    return null;
  }

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="admin-modal admin-modal--wide"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="admin-modal__header">
          <h3>KYC認證紀錄</h3>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="admin-modal__body">
          {loading && <p className="page-desc">載入中…</p>}
          {error && <p className="form-error">{error}</p>}
          {!loading && !error && (
            <div className="table-wrap">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>時間</th>
                    <th>操作</th>
                    <th>申請狀態</th>
                    <th>證件(正面)</th>
                    <th>證件(反面)</th>
                    <th>備註</th>
                    <th>操作者</th>
                  </tr>
                </thead>
                <tbody>
                  {records.length === 0 ? (
                    <tr>
                      <td colSpan={7} className="table-empty">
                        暫無數據
                      </td>
                    </tr>
                  ) : (
                    records.map((row, index) => {
                      const code = statusCode(row.realNameStatus);
                      return (
                        <tr key={`${row.time}-${index}`}>
                          <td>{formatDateTime(row.time)}</td>
                          <td>{formatKycJourneyAction(row.action)}</td>
                          <td>
                            <span className={kycStatusClassName(code)}>
                              {formatRealNameStatus(code)}
                            </span>
                          </td>
                          <td>
                            {row.identityImageFront ? (
                              <img src={resolveAdminMediaUrl(row.identityImageFront)} alt="正面" className="kyc-id-thumb" />
                            ) : (
                              '—'
                            )}
                          </td>
                          <td>
                            {row.identityImageBack ? (
                              <img src={resolveAdminMediaUrl(row.identityImageBack)} alt="反面" className="kyc-id-thumb" />
                            ) : (
                              '—'
                            )}
                          </td>
                          <td>{row.remark || '—'}</td>
                          <td>{row.operatorName || '—'}</td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div className="admin-modal__footer admin-modal__footer--center">
          <button type="button" className="btn btn-danger" onClick={onClose}>
            關閉
          </button>
        </div>
      </div>
    </div>
  );
}
